import { useMutation } from "@tanstack/react-query"

import { trpcOptions } from "../trpc"

export function useUpsertClaimMarker() {
  return useMutation(trpcOptions.app.upsertClaimMarker.mutationOptions())
}
